import { defineMessage } from 'services/localization';

export const messages = {
    goBack: defineMessage('go_back'),
    goTo: defineMessage('go_to_contentname'),
    backTo: defineMessage('back_to_contentname'),
};
